import { TIsNamespace } from './types';
import { NameSpace } from '../../../constants/NameSpace';
import { equals } from 'ramda';

export const isWixMusicNamespace: TIsNamespace = equals(NameSpace.WixMusic);
export const isWixVideoNamespace: TIsNamespace = equals(NameSpace.WixVideo);
export const isArtStoreNamespace: TIsNamespace = equals(NameSpace.ArtStore);
export const isDigitalProductNamespace: TIsNamespace = equals(NameSpace.DigitalProduct);
export const isAllNamespace: TIsNamespace = equals(NameSpace.All);
